module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Novo Funcionário",
      "modal": _vm.showFormEdit,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [(_vm.formData.id == 0) ? _c('ed-input-auto-complete', {
    staticClass: "text-left col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Funcionário",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.lstFuncionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "itemText": "funcionario"
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.setFuncionario
    },
    model: {
      value: (_vm.formData.id_funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_funcionario", $$v)
      },
      expression: "formData.id_funcionario"
    }
  }) : (_vm.formData.funcionario && _vm.formData.id > 0) ? _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Trabalhador(a)",
      "type": "text",
      "required": "",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.funcionario.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.funcionario, "nome", $$v)
      },
      expression: "formData.funcionario.nome"
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-input-text-area', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Descrição das Atividades do funcionário",
      "type": "text",
      "maxlength": "999",
      "required": ""
    },
    model: {
      value: (_vm.formData.descricao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "descricao", $$v)
      },
      expression: "formData.descricao"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo Funcionário",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatFuncionario,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9cb22a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/ghe/funcionario.vue
// module id = 1497
// module chunks = 44